export default "__VITE_ASSET__D3irq2Sa__"